var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_347",
    "data-name": "Group 347",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.275,
    height: 25.194,
    viewBox: "0 0 34.275 25.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M295.29,355.837a.871.871,0,0,0-1.254-1.209h0l-.023.023-3.321,3.369-3.4-3.374-.02-.02h0a.872.872,0,0,0-1.333,1.108h0a.876.876,0,0,0,.247.247l3.254,3.254-3.376,3.319a.872.872,0,0,0,1.16,1.3h0a.859.859,0,0,0,.093-.091l3.35-3.282,3.317,3.275a.861.861,0,0,0,.1.1h0a.872.872,0,0,0,1.143-1.315l-3.311-3.329,3.308-3.307A.839.839,0,0,0,295.29,355.837Z",
    transform: "translate(-270.395 -346.644)",
    fill: "#37b3a2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M192.719,293.21H177.312a6.366,6.366,0,0,0-4.727,2.1l-7.768,8.614a2.815,2.815,0,0,0-.023,3.744l7.276,8.273a7.246,7.246,0,0,0,5.441,2.461h15.174a5.683,5.683,0,0,0,5.683-5.683V298.858A5.648,5.648,0,0,0,192.719,293.21Zm3.846,19.834a3.642,3.642,0,0,1-3.642,3.642H177.761a6.334,6.334,0,0,1-4.708-2.1l-7.2-8a1.151,1.151,0,0,1,.013-1.554l7.772-8.354a5.57,5.57,0,0,1,4.078-1.776H192.67a3.9,3.9,0,0,1,3.9,3.9Z",
    transform: "translate(-164.092 -293.21)",
    fill: "#37b3a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.4781025c.svg";
export { ForwardRef as ReactComponent };